export default __webpack_public_path__ + "static/test-flight-button-f6b4adcf2fc07de24a05b28a38e45b27.png";